jQuery(function ($) {
  $('.ui-breadcrumb__dropdown-toggle').on('click', function () {
    const $btn = $(this);
    const $menu = $btn.next('.ui-breadcrumb__dropdown-menu');

    const expanded = $btn.attr('aria-expanded') === 'true';
    $btn.attr('aria-expanded', !expanded);
    $menu.toggleClass('is-open');
  });
});
